module.exports = __webpack_public_path__ + "img/report-5.d5dcb43a.jpg";